import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { getAxios } from "src/helpers/index";
import _ from 'lodash'
import { notificationObject } from "src/constant";

/** API call to retrieve all depots data with available and occupied space ------------------------ **/
export const getAllDepots = createAsyncThunk("depotUsers/getAllDepot", async (model, thunkAPi) => {
  try {
    let res = await getAxios().get("/Depot");
    let NewData = _.orderBy(res?.data, ["createdOn"], ["desc"])
    return thunkAPi.fulfillWithValue(NewData);
  } catch (error) {
    return thunkAPi.rejectWithValue(error);
  }
});

/** API call to add new depot --------------------------- **/
export const addNewDepot = createAsyncThunk("depotUsers/addNewDepot", async (model, thunkAPi) => {
  try {
    await getAxios().post("Depot", model);
    let notficationObj = {
      // DepotId: postResult?.data,
      Event: "DepotCreatedEvent",
      ResourceName: model?.name,
      ...notificationObject("Depot", "Create")
    }
    await getAxios().post("/ActivityLog", { activityLogs: [JSON.stringify(notficationObj)] });
    let getResult = await getAxios().get("/Depot");
    return getResult.data;
  } catch (error) {
    return thunkAPi.rejectWithValue(error);
  }
});

/** API call to edit depot --------------------------  **/
export const editDepot = createAsyncThunk("depotUsers/editDepot", async (model, thunkAPi) => {
  const { data } = model;
  try {
    await getAxios().put(`Depot/${data?.id}`, data);
    let NotificationArray = []
    let notficationObj = {}
    if (data?.allocateManager) {
      data?.NewAllocationManager.map((newData) => {
        notficationObj = {
          DepotId: data?.id,
          Event: "DepotAllocateEvent",
          UserDetails: newData.firstName + " " + newData?.middleName + " " + newData?.lastName,
          ResourceName: data?.name,
          ...notificationObject("DepotUser", "DepotUser Allocated")
        }
        NotificationArray.push(JSON.stringify(notficationObj))
      })
    }
    else if (data?.removeAllocationActivity) {
      notficationObj = {
        DepotId: data?.id,
        Event: "DepotDeAllocateEvent",
        UserDetails: (data?.NewDeallocationUsers?.firstName || "") + " " + (data?.NewDeallocationUsers?.middleName || "") + " " + (data?.NewDeallocationUsers?.lastName || ""),
        ResourceName: data?.name,
        ...notificationObject("DepotUser", "HasAllocated False")
      }
    }
    else {
      notficationObj = {
        // DepotId: data?.id,
        Event: "DepotUpdatedEvent",
        ResourceName: data?.name,
        ...notificationObject("Depot", "Update")
      }
    }
    let activityLogsObj = NotificationArray.length > 0 ? [...NotificationArray] : [JSON.stringify(notficationObj)]
    await getAxios().post("/ActivityLog", { activityLogs: activityLogsObj });
    let res = await getAxios().get("/Depot");
    return res.data;
  } catch (error) {
    return thunkAPi.rejectWithValue(error);
  }
});

/** To save the currently selected admin tab name -------------------- **/
export const setCurrentSelectedTab = createAction(
  'depotUsers/setCurrentSelectedTab',
  (model) => {
    return { payload: model }
  }
)

/** API call to de-activate depot personnel account ------------------------ **/
export const DeactiveAccount = createAsyncThunk(
  "depotUsers/DeactiveAccount",
  async (model, thunkAPi) => {
    const { id } = model;
    try {
      await getAxios().put(`User/deallocate/${id}`, {
        id: id
      });
      let activeDepots = _.map(_.filter(model?.depots || [], (d) => d.hasAllocated), (d1) => d1.name)
      let notficationObj = {
        Event: "AccountDeactiveAccount",
        UserDetails: model.firstName + " " + model?.middleName + " " + model?.lastName,
        ResourceName: activeDepots.join(" "),
        ...notificationObject("Depot", "Deactivate DepotUser")
      }
      await getAxios().post("/ActivityLog", { activityLogs: [JSON.stringify(notficationObj)] });
      let res = await getAxios().get("/Depot");
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** API call to retrieve all depot personnel data --------------------- **/
export const getAllDepotPerson = createAsyncThunk("depotUsers/getAllDepotPerson", async (model, thunkAPi) => {
  try {
    let res = await getAxios().get(`User`);
    let filterData = _.filter(res.data, (d) => d.isDepotManager || d?.roles?.includes("DepotManager") || d.roles.includes("Admin"));
    let NewData = _.orderBy(filterData, ["raisedOn"], ["desc"])
    return thunkAPi.fulfillWithValue(NewData);
  } catch (error) {
    return thunkAPi.rejectWithValue(error);
  }
});

/** API call to add new depot personnel or add new project manager ---------------------**/
export const addNewDepotPersonal = createAsyncThunk(
  "depotUsers/addNewDepotPersonal",
  async (model, thunkAPi) => {
    try {
      let notficationObj = {
        Event: model?.isProjectManager ? "DepotAddNewProjectManagerEvent" : "DepotAddNewDepoPersonalEvent",
        Name: model.firstName + " " + model?.middleName + " " + model?.lastName,
        Role: model?.isProjectManager ? "ProjectManager" : "DepotManager",
        clientName: model?.clientName,
        ...notificationObject("User", "Create")
      }
      let res = await getAxios().post("User", model);
      await getAxios().post("/ActivityLog", { activityLogs: [JSON.stringify(notficationObj)] });
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** API call to edit existing depot personnel or edit existing project manager -------------- **/
export const EditDepotPersonal = createAsyncThunk(
  "depotUsers/EditDepotPersonal",
  async (model, thunkAPi) => {
    const { id, data, removeProjectData } = model
    let notficationObj = {}
    let NotificationArray = []
    try {
      if (data?.assignProject) {
        data?.assignProject.map((newData) => {
          notficationObj = {
            ProjectId: newData?.id,
            Event: "projectAssignEvent",
            UserDetails: data.firstName + " " + data?.middleName + " " + data?.lastName,
            ResourceName: newData?.name,
            ...notificationObject("ProjectUser", "ProjectUser Allocated")
          }
          NotificationArray.push(JSON.stringify(notficationObj))
        })
      }
      else if (model?.removeProject) {
        notficationObj = {
          projectId: data?.id,
          Event: "projectDeAllocateEvent",
          UserDetails: (data?.firstName || "") + " " + (data?.middleName || "") + " " + (data?.lastName || ""),
          ResourceName: removeProjectData?.name,
          ...notificationObject("ProjectUser", "HasAllocated False")
        }
      } else {
        notficationObj = {
          Event: model?.isProjectManager ? "DepotProjectManagerUpdateEvent" : "DepotDepoPersonalUpdateEvent",
          Name: (data?.firstName || '') + " " + (data?.middleName || '') + " " + (data?.lastName || ''),
          UserDetails: (data?.firstName || '') + " " + (data?.middleName || '') + " " + (data?.lastName || ''),
          Role: model?.isProjectManager ? "ProjectManager" : "DepotManager",
          ...notificationObject("User", "Update")
        }
      }
      let activityLogsObj = NotificationArray.length > 0 ? [...NotificationArray] : [JSON.stringify(notficationObj)]

      let res = await getAxios().put(`User/${id}`, { ...data, id: id });
      await getAxios().post("/ActivityLog", { activityLogs: activityLogsObj });
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** API call to unlist depot ------------------- **/
export const unlistDepot = createAsyncThunk("depotUsers/unlistDepot", async (model, thunkAPi) => {
  try {
    let notficationObj = {
      Event: "DepotUnlistEvent",
      ResourceName: model?.data?.name,
      ...notificationObject("Depot", "Delete")
    }
    await getAxios().delete(`Depot/${model.id}`);
    await getAxios().post("/ActivityLog", { activityLogs: [JSON.stringify(notficationObj)] });
    let getResult = await getAxios().get("/Depot");
    return getResult.data;
  } catch (error) {
    return thunkAPi.rejectWithValue(error);
  }
});

/** API call to retrieve individual depot data by id --------------------**/
export const getByIdDepot = createAsyncThunk(
  "depotUsers/getByIdDepot",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().get(`Depot/${model}`);
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** API call to retrieve individual depot personnel or individual project manager data by id ----------------------**/
export const getByIdDepotPersonal = createAsyncThunk(
  "depotUsers/getByIdDepotPersonal",
  async (model, thunkAPi) => {
    try {
      let res = await getAxios().get(`User/${model}`);
      return res.data;
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);

/** API call to unlist depot personnel or unlist project manager -----------------------**/
export const unlistDepotPersonnel = createAsyncThunk(
  "depotUsers/unlistDepotPersonnel",
  async (model, thunkAPi) => {
    try {
      let notficationObj = {}
      if (model?.ProjectUser) {
        notficationObj = {
          Event: "ProjectUnlistEvent",
          UserDetails: (model?.firstName || '') + " " + (model?.middleName || '') + " " + (model?.lastName || ''),
          ...notificationObject("User", "Delete")
        }
      } else {
        notficationObj = {
          Event: "DepotUnlistEvent",
          UserDetails: (model?.data?.firstName || '') + " " + (model?.data?.middleName || '') + " " + (model?.data?.lastName || ''),
          ...notificationObject("User", "Delete")
        }
      }
      let res = await getAxios().delete(`User/${model?.id}`)
      await getAxios().post("/ActivityLog", { activityLogs: [JSON.stringify(notficationObj)] });
      return thunkAPi.fulfillWithValue(res.data);
    } catch (error) {
      return thunkAPi.rejectWithValue(error);
    }
  }
);


